import {Modal, ModalTypeMap} from "@mui/joy";

export function AppModal(props: ModalTypeMap['props']) {
    return <Modal {...{...props, sx: {backdropFilter: "blur(0px)", ...props.sx}}} children={props.children}/>;
}
